<template>
<el-button class="sl-el-btn" :class="{className,'sl-disabled':disabled}" :icon="icon" :loading="loading" :disabled="disabled">{{text}}</el-button>
</template>
<script>
export default {
  name: 'sl-btn',
  props: {
    icon: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style>
.sl-el-btn.el-button {
  border-radius: 2px;
  background: #FFFFFF;
  border: 1px solid #C8C8C8;
  padding: 8px;
  font-family: Avenir-Book;
  font-size: 12px;
  color: #000000;
  height: 30px;
}

.sl-el-btn.el-button:hover {
  background: #FFFBF8;
  border: 1px solid #E16607;
  border-radius: 2px;
  color: #E16607;
}


/*.sl-el-btn.el-button span {
  vertical-align: text-bottom;
}*/

.sl-btn-blue.sl-el-btn.el-button {
  background: #20a0ff;
  color: #FFFFFF;
  border: 1px solid #20a0ff;
  border-radius: 5px;
}

.sl-btn-blue.sl-el-btn.el-button:hover {
  background: #20a0ff;
  color: #FFFFFF;
  border: 1px solid #20a0ff;
}

.sl-btn-lightblue.sl-el-btn.el-button {}

.sl-btn-lightblue.sl-el-btn.el-button:hover {
  background: #F5FAFF;
  border: 1px solid #20a0ff;
  color: #20a0ff;
}

.sl-btn-lightred.sl-el-btn.el-button {}

.sl-btn-lightred.sl-el-btn.el-button:hover {
  background: #FFF6F7;
  border: 1px solid #E9001C;
  color: #E9001C;
}

.sl-btn-green.sl-el-btn.el-button {
  background: #67c23a;
  color: #FFFFFF;
  border: 1px solid #67c23a;
}

.sl-btn-green.sl-el-btn.el-button:hover {
  background: #85ce61;
  border: 1px solid #85ce61;
  color: #FFFFFF;
}

.sl-el-btn.el-button [class^="el-icon-sl-"],
.sl-el-btn.el-button [class*=" el-icon-sl-"] {
  font-size: 8px;
  position: relative;
  top: -1px;
}

[class^="el-icon-sl-"],
[class*=" el-icon-sl-"] {
  font-family: "iconfont" !important;
  font-size: inherit;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.sl-disabled.sl-el-btn.el-button,
.sl-disabled.sl-el-btn.el-button:hover {
  background: #F7F7F7;
  border: 1px solid #CCCCCC;
  color: #BCBCBC;
}
</style>



// WEBPACK FOOTER //
// sl-btn.vue?8297a5ba